import type { ActionType } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines';
import type {
  DeploysPayload,
  PublishingFulfilledPayload,
  PublishingMeta,
  PublishingPendingPayload,
  PublishingRejectedPayload
} from './types';

export const DEPLOY_SITE = 'staticSite/DEPLOY_SITE';

export const getLatestDeploys = createRoutine('staticSite/GET_LATEST_DEPLOYS')<
  undefined,
  undefined,
  undefined,
  DeploysPayload,
  DeploysPayload,
  undefined
>();

export const saveSite = createRoutine('sites/SAVE_SITE')<
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined
>();

export const publishSite = createRoutine('sites/PUBLISH_SITE')<
  PublishingMeta,
  undefined,
  PublishingPendingPayload,
  PublishingFulfilledPayload,
  PublishingRejectedPayload,
  undefined
>();

export const publishSiteRequested = publishSite.requested.bind(null, undefined);

export type Actions =
  | ActionType<typeof getLatestDeploys>
  | ActionType<typeof saveSite>
  | ActionType<typeof publishSite>;
